import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem } from '@material-ui/core';
import MarkMissingIcon from '@material-ui/icons/ReportProblem';
import MarkFoundIcon from '@material-ui/icons/CheckCircleOutline';
import { actions } from '../../actions/bikesActions';

const styles = theme => ({
  button: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
});

class MarkBikeMissingStatusAction extends React.Component {
  state = {
    dialogVisible: false,
    submitting: false,
  };

  handleStart = () => {
    this.setState({ dialogVisible: true });
  };

  handleCancel = () => {
    this.setState({ dialogVisible: false });
  };

  handleConfirm = () => {
    const { actions, bikesIds, markAsMissing } = this.props;
    this.setState({ submitting: true });

    const action = markAsMissing
      ? actions.markMissing(bikesIds)
      : actions.markFound(bikesIds);

    return action
      .then(() => this.setState({ dialogVisible: false, submitting: false }))
      .then(() => this.props.onActionExecuted());
  };

  renderTrigger(label, Icon) {
    const { classes, disabled, menuItem } = this.props;
    if (menuItem) {
      return (
        <MenuItem onClick={this.handleStart} disabled={disabled}>
          <Icon className={classes.icon} />
          {label}
        </MenuItem>
      );
    }

    return (
      <Button
        size="small"
        variant="outlined"
        className={classes.button}
        onClick={this.handleStart}
        disabled={disabled}
      >
        <Icon className={classes.icon} />
        {label}
      </Button>
    );
  }

  render() {
    const { bikesIds, fullScreen, markAsMissing } = this.props;
    const label = markAsMissing ? 'Oznacz jako zaginiony' : 'Oznacz jako odnaleziony';
    const title = markAsMissing ? 'Oznaczenie roweru jako zaginiony' : 'Oznaczenie roweru jako odnaleziony';
    const Icon = markAsMissing ? MarkMissingIcon : MarkFoundIcon;

    return (
      <React.Fragment>
        {this.renderTrigger(label, Icon)}
        <Dialog open={this.state.dialogVisible} fullScreen={fullScreen} fullWidth={true}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            Liczba wybranych rowerów: <strong>{bikesIds.length}</strong>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCancel} disabled={this.state.submitting}>
              Anuluj
            </Button>
            <Button
              onClick={this.handleConfirm}
              disabled={this.state.submitting}
              color="secondary"
            >
              Potwierdź
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

MarkBikeMissingStatusAction.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  bikesIds: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onActionExecuted: PropTypes.func.isRequired,
  markAsMissing: PropTypes.bool.isRequired,
  menuItem: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default compose(
  connect(null, mapDispatchToProps),
  withMobileDialog(),
  withStyles(styles)
)(MarkBikeMissingStatusAction);
